export class ProcesosDTO {

}

export class requestOrder {
    idProyecto: number;
    oldId: number;
    newId: number;
}

export class RequestNombre {
    nombreCiudad: string;
}